export default "__VITE_ASSET__BkPT8HMH__"